import styled from 'styled-components'

import { fadeIn } from '../../components'

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0;
  box-sizing: border-box;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 100%;
  min-width: 100%;
  position: relative;
  background: #fff;

  ${fadeIn}

  * {
    font-family: 'Nunito', 'sans-serif';
  }

  > div {
    &#stores-list-loading {
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      min-width: calc(100% - 2.5rem);
      max-width: calc(100% - 2.5rem);
      flex: 1;
    }
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
`

export const ContentWrapper = styled.div`
  flex: 1;
  flex-direction: column;
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.25rem;
  position: relative;
  box-sizing: border-box;
  max-width: 100%;
  position: relative;

  ${fadeIn}

  > div {
    display: flex;
    flex-direction: column;

    padding: 0;

    &#stores-list-search {
      margin-bottom: 1.875rem;
    }
  }
	
	@media (min-width: 60rem){
		padding: 0 1.25rem 1.25rem 1.25rem;
	}
`

export const H1 = styled.h1`
	color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
	margin: 0;
	padding: 1rem 0;
	font-size: 1rem;
	line-height: 1.25rem;
	font-weight: bold;
	min-width: 100%;
	text-transform: none;
	text-align: center;
	padding-bottom: 1.25rem;

	@media (min-width: 60rem) {
		text-align: left;
		font-size: 1.25rem;
		text-transform: uppercase;
    padding: 1rem 0;
    margin: 1rem 1rem 0 1rem;
    min-width: calc(100% - 2rem);
	}

	@media (max-width:40rem){
		border-bottom: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textThirdColor) || '#000' } .063rem solid;
	}
`
export const CartHeaderWrapper = styled.header`
  width: 100%;

  > button {
    &.close {
      background: none;
      padding: 0;
      margin: 0;
      position: absolute;
      right: 1.25rem;
      top: 1.25rem;
      font-size: 1.25rem;
      font-weight: 100;
    }
  }

  @media (min-width: 50rem) {
    display: none;
  }
`
export const CloseButton = styled.button`
  color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000'};
  background: none;
  border: 0 none;
  padding: 0;
  margin: 0;
`
export const H2 = styled.h2`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  line-height: 1.25rem;
  font-weight: bold;
  min-width: 100%;
`

export const Paragraph = styled.p`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#333' };
  margin: 0;
  padding: 0;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: bold;
  min-width: 100%;
  padding-bottom: 1.25rem;
`
